import React, { useState, useEffect } from "react";
import { AllRangePicker } from "../../../components/atoms/formFields/rangePicker/allRangePicker";
import { useDispatch, useSelector } from "react-redux";
import { reportsAnalyticsStockInfoThunk } from "../../../store/thunks/reportsAnalyticsThunk";
import moment from "moment/moment";
import TableLoader from "../../../components/atoms/Loader/tableLoader";
import VendorStore from "../../../components/atoms/vendorStores";
import Select from "react-select";
import { Pagination } from "../../../components/atoms/pagination";

export default function StockAvailability() {
  const dispatch = useDispatch();
  const {
    list: data,
    loading,
    pageInfo,
  } = useSelector((state) => state?.reportAnalyticsStockInfo || {});
  const { storeId } = useSelector((state) => state?.storeData || {});

  const [offset, setOffset] = useState(0);
  const [filter, setFilter] = useState({
    stock: "",
    fromDate: "",
    toDate: "",
  });
  useEffect(() => {
    if (storeId) {
      setFilter((prev) => ({
        ...prev,
        inventoryId: storeId,
      }));
    }
  }, [storeId]);

  useEffect(() => {
    dispatch(
      reportsAnalyticsStockInfoThunk({
        inventoryReportPagination: {
          paginationFilter: { limit: 10, offset: offset, order: "DESC" },
          fromDate: filter?.fromDate,
          toDate: filter?.toDate,
          inventoryId: filter?.inventoryId,
          ...(filter?.stock && { stock: filter?.stock }),
        },
      })
    );
  }, [dispatch, filter, offset]);

  return (
    <>
      <div className="d-flex justify-content-between my-5">
        <VendorStore
          value={filter?.inventoryId}
          onChange={(val) => {
            if (val) {
              setFilter({
                ...filter,
                inventoryId: val.value,
              });
              setOffset(0);
            } else {
              setFilter({
                ...filter,
                inventoryId: "",
              });
              setOffset(0);
            }
          }}
        />

        <div className="form-group m-0 row mr-5">
          <label className="col-form-label font-weight-bolder mr-4">
            Stock :
          </label>
          <div className="store_option w-180px mr-5">
            <Select
              placeholder="Search Stock"
              isClearable
              options={[
                { label: "In-Stock", value: "true" },
                { label: "Out-Stock", value: "false" },
              ]}
              onChange={(val) => {
                if (val) {
                  setFilter({
                    ...filter,
                    stock: val.value,
                  });
                  setOffset(0);
                } else {
                  setFilter({
                    ...filter,
                    stock: "",
                  });
                  setOffset(0);
                }
              }}
            ></Select>
          </div>

          <AllRangePicker
            disabledDate={(current) => {
              return moment().add(0, "days") <= current;
            }}
            onChange={(value, dateString) => {
              if (value) {
                setFilter({
                  ...filter,
                  fromDate: moment(value[0]["$d"]).format("DD/MM/YYYY"),
                  toDate: moment(value[1]["$d"]).format("DD/MM/YYYY"),
                });
                setOffset(0);
              } else {
                setFilter({
                  fromDate: null,
                  toDate: null,
                });
                setOffset(0);
              }
            }}
          />
        </div>
      </div>

      <div className="table-responsive font-weight-bold">
        <table className="table table-bordered m-0 border radius-remove all_domain_table">
          <thead className="text-white bg-gray-700">
            <tr>
              <th className="font-weight-bolder font-size-lg all_table_id_number">
                S.No.
              </th>
              <th className="width">Product Type</th>
              <th className="width">Product Image</th>
              <th className="width">Product Name & SKU</th>
              <th className="width">Units in Stock</th>
              <th className="width">Stock Status</th>
            </tr>
          </thead>

          <tbody className="font-weight-bold">
            {loading ? (
              <tr>
                <td colSpan={6}>
                  <TableLoader />
                </td>
              </tr>
            ) : data?.length > 0 ? (
              data.map((obj, i) => {
                const { en: product_type } = obj.productType;
                const { en: product_name } = obj.productName;
                const masterVariant = obj.variantInfo[0];
                return (
                  <>
                    <tr>
                      <td className="">{i + 1 + offset * 10}</td>
                      <td className="">
                        {obj.variantInfo && obj.variantInfo.length > 0 ? (
                          <span
                            className="btn btn-icon btn-light btn-xs btn-hover-primary mr-5 view-button collapsed"
                            data-target={`#product_variant_${i}`}
                            data-toggle="collapse"
                          ></span>
                        ) : (
                          ""
                        )}
                        {product_type}
                      </td>
                      <td className="">
                        <img
                          src={masterVariant.imageUrl}
                          className="max-w-70px"
                          alt=""
                        />
                      </td>
                      <td className="text-left" nowrap="nowrap">
                        <span className="font-weight-bolder">
                          {product_name}
                        </span>
                        <span className="mt-2 d-block">
                          SKU {masterVariant.sku}
                        </span>
                      </td>
                      <td className="">{masterVariant.stockSize}</td>
                      <td>
                        <span
                          className={`p-1 px-2 text-white rounded font-size-sm ${
                            masterVariant.stockStatus === "OUT STOCK"
                              ? "bg-danger"
                              : "bg-success"
                          }`}
                        >
                          {masterVariant.stockStatus}
                        </span>
                      </td>
                    </tr>

                    {obj?.variantInfo?.map((variantObj, index) => {
                      const { imageUrl, sku, stockSize, stockStatus, variant } =
                        variantObj;
                      return (
                        <>
                          {/*Variable Product Start*/}
                          <tr
                            className="collapse table-collapse-bg"
                            id={`product_variant_${i}`}
                          >
                            <td className=""></td>
                            <td className=""></td>
                            <td className="">
                              <img
                                src={imageUrl}
                                className="max-w-70px"
                                alt=""
                              />
                            </td>
                            <td className="text-left" nowrap="nowrap">
                              <span className="font-weight-bolder">
                                {product_name}-{variant}
                              </span>
                              <span className="mt-2 d-block">SKU {sku}</span>
                            </td>
                            <td className="">{stockSize}</td>
                            <td>
                              <span
                                className={`p-1 px-2 text-white rounded font-size-sm ${
                                  stockStatus === "OUT STOCK"
                                    ? "bg-danger"
                                    : " bg-success"
                                }`}
                              >
                                {stockStatus}
                              </span>
                            </td>
                          </tr>
                          {/*Variable Product End*/}
                        </>
                      );
                    })}
                  </>
                );
              })
            ) : (
              <tr>
                <td colSpan={12}>No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="my-5">
        <Pagination pageInfo={pageInfo} setOffset={setOffset} offset={offset} />
      </div>
    </>
  );
}
